import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Router} from "@angular/router";
import {FacadeService} from "../../services/facade.service";

@Component({
  selector: 'success-dialog',
  templateUrl: './success-dialog.component.html'
})
export class SuccessDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<SuccessDialogComponent>,
    private router: Router,
    private facade: FacadeService,
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; messageSecondary: string; uniqueLink: string; uniqueCode?: string; sessionId: string, showViewApplicationButton?: string;}
  ) {}

  /**
   * Called when view is clicked.
   */
  onView(): void {
    this.router.navigate([`/applications/${this.data.sessionId}`]);
  }

  /**
   * Called when dismiss is clicked.
   * Redirect to same page. Form reset not working as expected on dialog close.
   */
  onDismiss(): void {
    this.facade.refreshPage();
  }
}
